
import { ChangeDetectionStrategy, Component, ChangeDetectorRef, inject } from '@angular/core';
import type { CustomAutomationData } from '@fitness-force/models';
import { AngularQueryBuilderComponent } from '@fitness-force/shared';
import { TranslateModule } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';
import { StyleClassModule } from 'primeng/styleclass';


@Component({
  selector: 'fitness-force-rule-builder-popup',
  templateUrl: './rule-builder-popup.component.html',
  styleUrls: ['./rule-builder-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[ToastMessageService],
  standalone: true,
  imports: [
    StyleClassModule,
    MessageModule,
    ButtonModule,
    AngularQueryBuilderComponent,
    TranslateModule
]
})
export class RuleBuilderPopupComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);
  private readonly cd = inject(ChangeDetectorRef);

  modelData:CustomAutomationData ={} as CustomAutomationData;
  eventType:string="";
  rule:string="";
  sqlRule:string="";
  uiJsonRule = "";
  
  constructor() {
    if (this.config.data) {
      this.modelData = this.config.data;
      this.eventType = this.modelData.automationType!.toString()
    }
   }


  useRule()
  {
    this.modelData.sqlRule= this.rule;
    this.modelData.sqlQuery = this.sqlRule;
    this.modelData.jsonRule = this.uiJsonRule;
    this.ref.close(this.modelData);
  }

  closePopup()
  {
    this.ref.close(this.modelData);
  }

  getRule(event: { rule: string; sqlRule: string; jsonRule: string }) {
    this.rule = event.rule;
    this.sqlRule= event.sqlRule;
    this.uiJsonRule = event.jsonRule;
  }

}